/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportContactsV2MutationRequest,
  ExportContactsV2MutationResponse,
  ExportContactsV2400,
  ExportContactsV2500,
} from '../types/ExportContactsV2'

function getExportContactsV2Url() {
  const res = { method: 'POST', url: `/api/v1/contacts/export/v2/` as const }
  return res
}

/**
 * @description Start an async contacts export.
 * Request body:
 * {
 * "selected_columns": ["full_name", "email_work", "contact_company"],
 * "export_type": "csv",
 * "filter_params": { ... },
 * "sort": "-created"
 * }
 * Returns 202:
 * {
 * "request_id": 123,
 * "status": "pending",
 * "progress_percentage": 0,
 * "item_count": 0
 * }
 * @summary Start an async contacts export
 * {@link /api/v1/contacts/export/v2/}
 */
export async function exportContactsV2(
  data: ExportContactsV2MutationRequest,
  config: Partial<RequestConfig<ExportContactsV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportContactsV2MutationResponse,
    ResponseErrorConfig<ExportContactsV2400 | ExportContactsV2500>,
    ExportContactsV2MutationRequest
  >({
    method: 'POST',
    url: getExportContactsV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
